import React from 'react';
import Svg from 'rp-react-svg-icon';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import SubNavLink from './SubNavLink';
import { sireSubTabs } from '../helpers/tabNames';
import calculateTabUrl from '../helpers/calculateTabUrl';

const SubNav = ({
                    currentTab,
                    url,
                    hasWeatherbys,
                    isMobile,
                    onSubnavMenuExpand,
                    isExpanded,
                }) => {
    const tab = currentTab ||
        (hasWeatherbys ? 'weatherbys-overview' : 'progeny');

    const expandMenu = () => {
        onSubnavMenuExpand();
    };

    const isWeatherbysTab = sireSubTabs.stallionDetails.includes(tab);

    return (
        <div
            className={classNames(
                'pp-subTabs',
                isWeatherbysTab && 'pp-subTabs_weatherbys',
                (!isMobile || isExpanded) && 'pp-subTabs_weatherbys--all-visible',
            )}
        >
            {Object.values(sireSubTabs)
                .find(subTabs => subTabs.includes(tab))
                .map((subTab, i) => (
                    <SubNavLink
                        url={url}
                        tabName={subTab}
                        tabUrl={calculateTabUrl(currentTab, subTab, i)}
                        key={subTab}
                    />
                ))}

            {!isExpanded && isWeatherbysTab && (
                <button
                    className="ui-btn hidden-md-up pp-subTabs__expand-btn"
                    onClick={expandMenu}
                >
                    <Svg iconName="down" size="Medium" />
                </button>
            )}
        </div>
    );
};

SubNav.propTypes = {
    currentTab: PropTypes.string,
    url: PropTypes.string.isRequired,
    hasWeatherbys: PropTypes.bool.isRequired,
    isMobile: PropTypes.bool,
    onSubnavMenuExpand: PropTypes.func,
    isExpanded: PropTypes.bool,
};

export default SubNav;



// WEBPACK FOOTER //
// ./src/js/shared/nav/components/SubNav.jsx